var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455.111 71.111H56.89c-14.308 0-27.235 5.461-37.234 14.194l211.142 152.491h11.777L256 196.466l13.426 41.33h43.463L277.73 263.34l3.541 10.922 211.073 152.434C504.291 416.27 512 401.109 512 384V128c0-31.417-25.473-56.889-56.889-56.889",
    fill: "#078930"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291.157 304.669L256 279.125l-35.157 25.543 13.426-41.33-35.158-25.543H230.8L19.655 85.305C7.709 95.73 0 110.891 0 128v256c0 31.418 25.473 56.889 56.889 56.889H455.11c14.308 0 27.235-5.475 37.234-14.194L281.272 274.248l9.886 30.42z",
    fill: "#fcdd09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.269 263.339l-13.427 41.33L256 279.125l35.157 25.543-9.884-30.422-3.542-10.908 35.158-25.543h-43.463L256 196.466l-13.426 41.33H199.11l35.158 25.543z",
    fill: "#da121a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGf);
export default __webpack_public_path__ + "static/media/gf.2fbe8d6efe90f228ed8db3a81a0935ab.svg";
export { ForwardRef as ReactComponent };